import { render, staticRenderFns } from "./AddressManage.vue?vue&type=template&id=b38c1c3e&scoped=true&"
import script from "./AddressManage.vue?vue&type=script&lang=js&"
export * from "./AddressManage.vue?vue&type=script&lang=js&"
import style0 from "./AddressManage.vue?vue&type=style&index=0&id=b38c1c3e&scoped=true&lang=scss&"
import style1 from "./AddressManage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38c1c3e",
  null
  
)

export default component.exports